<template>
  <div>
    <el-form
      style="width:500px"
      ref="searchForm"
      :rules="searchRules"
      :model="searchForm"
      label-width="120px"
      size="mini"
      labelPosition="right"
      @submit.native.prevent
    >
      <el-form-item label="姓名" prop="name">
        <el-input v-model="searchForm.name" @keyup.enter.native="startSearch('searchForm')"></el-input>
      </el-form-item>
      <el-form-item label="所属社区" prop="district">
        <el-input v-model="searchForm.district" @keyup.enter.native="startSearch('searchForm')"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="searchForm.phone" @keyup.enter.native="startSearch('searchForm')"></el-input>
      </el-form-item>
      <el-form-item label="一键通号码" prop="pushToTalk">
        <el-input v-model="searchForm.pushToTalk" @keyup.enter.native="startSearch('searchForm')"></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="idcard">
        <el-input v-model="searchForm.idcard" @keyup.enter.native="startSearch('searchForm')"></el-input>
      </el-form-item>
      <el-form-item label="老人类型" prop="type">
        <el-radio-group v-model="searchForm.type">
         


          
           <el-radio :label="1">A1类老人</el-radio>
           <el-radio :label="2">A2类老人</el-radio>
          <el-radio :label="3">A3类老人</el-radio>
           <el-radio :label="4">A4类老人</el-radio>
          <el-radio :label="9">B类老人</el-radio>
          <el-radio :label="0">社会化老人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch('searchForm')">确定</el-button>
        <el-button @click="cancleSearch">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    let isNumber = this.$filter.isNumber;
    return {
      labelPosition: "left",
      searchForm: this.$store.state.currentSearchForm,
      searchRules: {
        idcard: [
          { validator: isNumber, trigger: "blur" },
          { max: 18, message: "输入正确的身份证号", trigger: "change" }
        ],
        phone: [
          { validator: isNumber, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    startSearch(formName) {
      //所有参数是否为空    是的话 return false   否的话
      if (this.$baseFunc.paramsValidate(this.searchForm)) {
        this.$message({
          type: "error",
          message: "请选择检索参数"
        });
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            searchShow: false,
            searchData: this.searchForm
          };
          this.$emit("startSearch", obj);
        } else {
          return false;
        }
      });
    },
    cancleSearch() {
      let obj = {
        searchShow: false
      };
      this.$emit("cancleSearch", obj);
    }
  },
  created() { }
};
</script>

